import axios from 'axios';

const state = {
	services: [],
	serviceList: [
		'mws',
		'googleMap',
		'AmazonAdvertising',
		'magento',
		'fattureInCloud',
		'paypal',
		'stripe',
		'aws',
		'googletranslate',
		'aliexpress',
		'store',
		'prestashop',
		'shopify',
		'woocommerce',
		'website',
		'spedisciOnline',
		'gls',
		'bartolini',
		'dhl',
		'ups',
		'barcode',
		'qrcode',
		'yoast',
	],
};

const getters = {
	getServices: state => {
		return state.services;
	},
};

const actions = {
	getServiceFetch: async (context, payload) => {
		try {
			const payloadfetch = [];
			payload.forEach(el => {
				//const findSetting =
				if (state.services.filter(eldata => eldata.service === el).length === 0) {
					payloadfetch.push(el);
				}
			});

			let url = 'services';
			const success = await axios.post(`${context.rootGetters['settings/getUrl']}${url}`, payloadfetch, {
				headers: { Authorization: `Bearer ${context.rootGetters['profile/getToken']}` },
				'Content-Type': 'application/json',
			});

			if (success) {
				for await (let data of success.data.data) {
					await context.commit('setServices', data);
				}
				return true;
			} else {
				return true;
			}
		} catch (error) {
			console.log(error);

			return error.response;
		}
	},
	getServiceFetchActive: async (context, payload) => {
		try {
			let url = 'services/status';
			const success = await axios.post(`${context.rootGetters['settings/getUrl']}${url}`, payload, {
				headers: { Authorization: `Bearer ${context.rootGetters['profile/getToken']}` },
				'Content-Type': 'application/json',
			});

			if (success) {
				return success.data.data;
			} else {
				return true;
			}
		} catch (error) {
			console.log(error);

			return error.response;
		}
	},

	destroyData: context => {
		//context.commit('setSetting', []);
	},
	// dopo un salvataggio: aggiorna il servizio in memoria (getServiceFetch non riscarica quelli gia' letti)
	updateData: async (context, setting) => {
		const service = state.services.find(el => el.service === setting.service);
		if (!service) {
			context.commit('setServices', setting);
			return;
		}
		Object.assign(service, setting);
		context.commit('updateServices', state.services);
	},
};

const mutations = {
	setServices: (state, value) => {
		const service = state.services.some(el => el.service === value.service);
		if (service) {
			return;
		}
		state.services.push(value);
	},
	updateServices: (state, value) => {
		state.services = value;
	},

	/*setMessages: (state, value) => {
		//console.log(value);
		if (value) {
			state.messages[value.key] = value.value;
		} else {
			state.messages = {};
		}
	},*/
};

export default {
	namespaced: true,
	state,
	mutations,
	getters,
	actions,
};
